var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgThumbtack = function SvgThumbtack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1417 10.3698L15.6638 5.75H17.3125C17.8303 5.75 18.25 5.33027 18.25 4.8125V2.9375C18.25 2.41973 17.8303 2 17.3125 2H6.6875C6.16972 2 5.75 2.41973 5.75 2.9375V4.8125C5.75 5.33027 6.16972 5.75 6.6875 5.75H8.33621L7.85828 10.3698C5.96347 11.2508 4.5 12.8305 4.5 14.8125C4.5 15.3303 4.91973 15.75 5.4375 15.75H10.75V19.8128C10.75 19.8613 10.7613 19.9091 10.783 19.9525L11.7205 21.8275C11.8354 22.0573 12.1644 22.0577 12.2795 21.8275L13.217 19.9525C13.2387 19.9091 13.25 19.8613 13.25 19.8128V15.75H18.5625C19.0803 15.75 19.5 15.3303 19.5 14.8125C19.5 12.8132 18.0163 11.2414 16.1417 10.3698Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThumbtack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thumbtack.1acc015b.svg";
export { ForwardRef as ReactComponent };